import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onWheel, onKeyDown, ...props }, ref) => {
  const handleWheel = (event) => {
    if (type === "number") {
      event.preventDefault();
      event.currentTarget.blur();
    }
    onWheel?.(event);
  };

  const handleKeyDown = (event) => {
    if (type === "number" && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
      event.preventDefault();
    }
    onKeyDown?.(event);
  };

  return (
    <input
      type={type}
      onWheel={handleWheel}
      onKeyDown={handleKeyDown}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
